<template>
  <v-container>
    <v-dialog v-model="notif.show" persistent max-width="600">
      <v-card class>
        <v-progress-linear :color="notif.mode" height="10" value="100"></v-progress-linear>
        <v-card-title class="headline">
          {{notif.title}}
          <v-btn color class="ml-auto center" @click="notif.show = false">
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </v-card>
      <v-list shaped>
        <v-list-item-content
          v-for="item in notif.text"
          :key="item"
          class="m-0 p-0 pt-0 pb-0 mt-0 mb-0"
        >
          <v-card-text>
            <b class="red--text">{{ item }}</b>
          </v-card-text>
          <v-divider horizontal class="mt-1 mb-3"></v-divider>
        </v-list-item-content>
      </v-list>
    </v-dialog>

    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('delete')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn
            :loading="deleteLoading"
            :disabled="deleteLoading"
            color="error"
            @click="remove(dataItem)"
          >{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Upload Dialog -->
    <v-dialog v-model="uploadDialog" max-width="750px">
      <v-form ref="form">
        <!-- Download Template -->
        <v-card class="pt-3">
          <v-card-title>
            <div class="row pb-0">
              <div class="col-10 pb-0">
                <span class="headline ml-2">{{$t('download_template')}}</span>
              </div>
              <div class="col-2 text-right pb-0">
                <v-btn icon right class="ml-auto" @click="uploadDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
               <div class="col-12 pb-0">
               <small
              class="ml-2 not-bold"
            >({{$t('note_download')}})</small>
               </div>
            </div>
            
           
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="8" sm="8">
                  <v-autocomplete
                    v-if="role != 3 || role === 3 && searchGroupList.length > 1"
                    v-model="uploadData.download.groupId"
                    :items="searchGroupList"
                    hide-no-data
                    hide-selected
                    item-text="alias"
                    item-value="id"
                    :label="$t('select_group')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="7" sm="7">
                  <v-select
                    v-model="uploadData.download.month"
                    :items="monthList"
                    hide-no-data
                    hide-selected
                    item-text="name"
                    item-value="id"
                    :label="$t('select_month')"
                  ></v-select>
                </v-col>
                 <v-col cols="5" sm="5">
                  <v-select
                    v-model="uploadData.download.year"
                    :items="yearList"
                    hide-no-data
                    hide-selected
                    :label="$t('select_year')"
                  ></v-select>
                </v-col>
                <v-col cols="3" sm="3">
                  <v-btn block color="primary" class="mt-3" @click="downloadSchedule()">{{$t('download')}}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <!-- Upload Template -->
          <v-card-title>
            <div class="row pb-0">
              <div class="col-12 pb-0">
                <span class="headline ml-2">{{$t('upload_template')}}</span>
              </div>
              <div class="col-12 pb-0">
                <small class="ml-2 not-bold">({{$t('please_upload')}})</small>
              </div>
            </div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="8" sm="8">
                  <v-autocomplete
                    v-if="role != 3 || role === 3 && searchGroupList.length > 1"
                    v-model="uploadData.upload.groupId"
                    :items="searchGroupList"
                    hide-no-data
                    hide-selected
                    item-text="alias"
                    item-value="id"
                    :label="$t('select_group')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-file-input
                    v-model="uploadData.upload.file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    :label="$t('template_file')"
                  ></v-file-input>
                </v-col>
                <v-col cols="3" sm="3">
                  <v-btn
                    :loading="uploadData.upload.loading"
                    block
                    color="primary"
                    class="mt-3"
                    @click="uploadSchedule"
                  >{{$t('upload')}}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Add / Edit Dialog -->
    <v-dialog v-model="dialog" max-width="750px">
      <v-form ref="form">
        <v-card class="pt-3">
          <v-card-title>
            <span class="headline ml-2">{{isEdit ? $t('update') : $t('update')}} {{$t('schedule')}}</span>
            <v-btn
              icon
              color="error"
              right
              class="ml-auto"
              @click="showDeleteDialog()"
              v-if="isEdit"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6" sm="6">
                  <v-autocomplete
                    :disabled="disableEdit"
                    v-model="dataItem.id"
                    :items="users"
                    hide-no-data
                    hide-selected
                    item-text="full_name"
                    item-value="id"
                    :label="$t('user_name')"
                    @change="changeUser"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-menu
                    ref="menu_date"
                    v-model="menu_date"
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :disabled="disableEdit"
                        :value="dateFormatted"
                        :label="$t('date')"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        color="primary"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dataItem.date"
                      @change="onDateChange"
                      no-title
                      :locale="$t('locale')"
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-text-field :label="$t('schedule_used')" v-model="dataItem.patternName" disabled></v-text-field>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-text-field :label="$t('schedule_day')" v-model="dataItem.day" disabled></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" class="shift-name">
                  <v-autocomplete
                    v-model="dataItem.shiftId"
                    :items="masterShift"
                    hide-no-data
                    item-text="shift_master.schedule_code"
                    item-value="id"
                    :label="$t('shift_name')"
                    @change="shiftChange($event)"
                    :rules="[validator.alfaNumberNotRequired]"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-text-field
                     :label="$t('shift_description')"
                    v-model="dataItem.shiftDescription"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-text-field :label="$t('work_in')" :value="dataItem.shiftWorkIn | hour" disabled></v-text-field>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-text-field :label="$t('work_out')" :value="dataItem.shiftWorkOut | hour" disabled></v-text-field>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-text-field :label="$t('break_in')" :value="dataItem.shiftBreakIn | hour" disabled></v-text-field>
                </v-col>
                <v-col cols="6" sm="6">
                  <v-text-field :label="$t('break_out')" :value="dataItem.shiftBreakOut | hour" disabled></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-6 pb-6">
            <v-row justify="center">
              <v-btn color="primary" text @click="dialog = false">{{$t('cancel')}}</v-btn>
              <v-btn
                :loading="loading"
                color="primary"
                dark
                @click="isEdit ? update(dataItem):insert(dataItem)"
              >{{$t('save')}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- <v-row>
      <v-col>
        <v-btn right color="primary" dark class="mb-2" @click="addItem()">Add Schedule</v-btn>
      </v-col>
    </v-row>-->

    <v-card class="px-6 pb-0">
      <v-row justify="center" align="center">
        <v-col md="3" sm="12" class="find-group">
          <v-autocomplete
            v-model="groupSearch"
            :items="searchGroupList"
            hide-no-data
            item-text="alias"
            item-value="id"
            :label="$t('find_group')"
            @change="refreshView(userSelected, $event, 'byGroup')"
            :rules="[validator.alfaNumberNotRequired]"
          ></v-autocomplete>
        </v-col>
        <v-col md="3" sm="12" class="find-user">
          <v-autocomplete
            v-model="userSelected"
            :items="users"
            hide-no-data
            item-text="full_name"
            item-value="id"
            :label="$t('find_user')"
            @change="refreshView($event, groupSearch, 'byUser')"
            :rules="[validator.alfaNumberNotRequired]"
          ></v-autocomplete>
        </v-col>
        <v-col offset="1" md="3" sm="12" >
            <v-btn outlined color="primary" block @click="showUploadDialog">
              <v-icon>mdi-download</v-icon>{{$t('upload_schedule')}}
            </v-btn>
        </v-col>
        <v-col md="2" sm="12" justify="center" align="center">
          <!-- <div class="mt-4 float-left">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="getDownloadList()">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>Export Schedule</span>
            </v-tooltip>
          </div>-->
          <div class="float-right">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="onWeekChange('prev')">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </template>
              <span>{{$t('previous_week')}}</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="onWeekChange('today')">
                  <v-icon>mdi-calendar</v-icon>
                </v-btn>
              </template>
              <span>{{$t('this_week')}}</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="onWeekChange('next')">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </template>
              <span>{{$t('next_week')}}</span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <div class="mt-3">
      <div v-if="bulkLoading" class="mt-5">
        <v-skeleton-loader class="mx-auto" type="table-tbody"></v-skeleton-loader>
      </div>
      <div v-else class="mt-5">
        <v-skeleton-loader class="mx-auto" type="table-tbody" v-if="loading"></v-skeleton-loader>
        <v-simple-table v-if="!loading">
          <template v-slot:default>
            <thead>
              <tr>
                <th v-for="(item, i) of tableHeader" v-bind:key="i">
                  <span v-if="todayDate == item.text" class="primary--text">{{item.text}}</span>
                  <span v-if="todayDate != item.text">{{item.text}}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, i) in dataSchedule" :key="i">
                <td
                  class="pl-1 pr-1"
                  v-for="(item, j) of tableHeader"
                  v-bind:key="j"
                  @click="clickSchedule(data, item)"
                >
                  <v-container v-if="j == 0">
                    <v-row>
                      <v-col>
                        <v-avatar size="32" class="ma-1">
                          <img
                            :src="data[tableHeader[j+1].value]?data[tableHeader[j+1].value].user.avatar_url != null ? data[tableHeader[j+1].value].user.avatar_url : 'img/neutral.png' : 'img/neutral.png'"
                            alt="Avatar"
                            onerror="this.onerror=null;this.src='img/neutral.png'"
                          />
                        </v-avatar>
                        {{data.name}}
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-container v-if="j != 0 && data[item.value]" class="pa-0">
                    <v-container v-if="data[item.value].shift_master" class="pa-0">
                      <!-- :color="data[item.value].shift_master.schedule_code != 'X' ? 'white': 'red'"
                      :dark="data[item.value].shift_master.schedule_code != 'X'? false : true"-->
                      <v-card :class="getHolidayClass(data[item.value].shift_master, item.text)">
                        <v-card-text class="pa-2">
                          <v-row>
                            <v-col md="12" class="pl-2 pt-2 pr-2 pb-0">
                              <b>{{data[item.value].shift_master.schedule_code}}</b>
                            </v-col>
                            <v-col
                              v-if="data[item.value].shift_master.work_in != null"
                              class="pl-2 pb-2 pt-0 pr-0 colored-text"
                            >{{data[item.value].shift_master.work_in | hour}} - {{data[item.value].shift_master.work_out | hour}}</v-col>
                            <v-col
                              v-if="data[item.value].shift_master.work_in == null"
                              cols="12"
                              class="pl-2 pb-2 pt-0 pr-0 colored-text pull-left"
                            >{{$t('dayoff')}}</v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-container>
                  </v-container>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
  </v-container>
</template>

<script>
import moment from 'moment'
import readXlsxFile from 'read-excel-file'

export default {
  name: "Work",
  data() {
    return {
      searchGroupList: [],
      notif: {
        show: false,
        mode: '',
        text: [],
        title: '',
      },
      todayDate: moment().locale(this.$i18n.t('lang')).format('ddd DD-MMM'),
      monthList: [
        { id: 1, name: 'Januari' },
        { id: 2, name: 'Februari' },
        { id: 3, name: 'Maret' },
        { id: 4, name: 'April' },
        { id: 5, name: 'Mei' },
        { id: 6, name: 'Juni' },
        { id: 7, name: 'Juli' },
        { id: 8, name: 'Agustus' },
        { id: 9, name: 'September' },
        { id: 10, name: 'Oktober' },
        { id: 11, name: 'November' },
        { id: 12, name: 'Desember' },
      ],
      yearList: [
        2023,
        2024,
        2025
      ],
      uploadData: {
        upload: {
          groupId: null,
          file: null,
          loading: false,
        },
        download: {
          groupId: null,
          month: null,
          year: null,
          loading: false,
        }
      },
      uploadDialog: false,
      inProggress: true,
      downloadList: [''],
      groupSearch: null,
      groupList: [],
      role: this.$store.state.role,
      groupId: this.$store.state.group_id,
      userSelected: null,
      deleteLoading: false,
      bulkLoading: false,
      disableEdit: false,
      deleteDialog: false,
      loading: false,      
      reset: false,
      isEdit: false,
      masterShift: [],
      dataItem: {
        id: '',
        name: '',
        date: '',
        shiftId: '',
        shiftDescription: '',
        shiftCode: '',
        shiftWorkIn: '',
        shiftWorkOut: '',
        shiftBreakIn: '',
        shiftBreakOut: '',
        scheduleId: '',
        patternName: '',
        day: null,
        tolerance: 0,
        interval: 0,
      },
      dialog: false,
      headers: [],
      search: null,
      dataSchedule: [],
      date: {
        start: '',
        end: '',
        week: 0,
      },

      date_start: '',
      menu_start: '',
      menu_date: '',

      company_id: this.$store.state.company,
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      users: [],
      patternByGroup: []
    }

  },
  methods: {
    async downloadSchedule() {
      const form = this.uploadData.download
      const userId = this.$store.state.user.id
      if(form.groupId){
      const url = `${this.baseUrl}/schedule/download?month=${form.month}&year=${form.year}&groupId=${form.groupId}&userId=${userId}`
        window.open(url)
      } else {
      const url = `${this.baseUrl}/schedule/download?month=${form.month}&year=${form.year}&userId=${userId}`
        window.open(url)
      }
    },
    getHolidayClass(schedule, date) {
      if (schedule.work_in == null && schedule.work_out == null) {
        return 'mx-auto cursor ma-1 red-outline'
      } else {
        if (date == this.todayDate) {
          return 'mx-auto cursor ma-1 blue-outline'
        } else {
          return 'mx-auto cursor ma-1'
        }
      }
    },
    async uploadSchedule() {
      if (this.uploadData.upload.groupId == null) return null
      if (this.uploadData.upload.file == null) return null
      this.uploadData.upload.loading = true
      const excelJson = await readXlsxFile(this.uploadData.upload.file)
      const body = {
        groupId: this.uploadData.upload.groupId,
        data: excelJson
      }
      const result = await this.$store.dispatch('saveScheduleUpload', body)
      this.uploadData.upload.loading = false
      if (result) {
        this.showMessage('Berhasil Di upload', 'success')
        this.refreshView(this.userSelected, this.groupSearch)
      }
    },
    showUploadDialog() {
      if (!this.inProggress) {
        this.uploadDialog = true
        if (this.role == 3) {
          const groupId = this.$store.state.user.detail.groupId
          this.uploadData.upload.groupId = groupId
          this.uploadData.download.groupId = groupId
        }
      } else {
        this.showMessage('Proccessing please wait.', 'info')
      }
    },
    addItem() {
      this.isEdit = false
      this.reset = true
      this.dialog = true
      this.disableEdit = false
    },
    shiftChange(data) {
      const shift = this.masterShift.find(e => { return e.id == data })
      if (shift) {
        this.dataItem.shiftId = shift.id
        this.dataItem.shiftDescription = shift.shift_master.description
        this.dataItem.shiftWorkIn = shift.shift_master.work_in
        this.dataItem.shiftWorkOut = shift.shift_master.work_out
        this.dataItem.shiftBreakIn = shift.shift_master.break_in
        this.dataItem.shiftBreakOut = shift.shift_master.break_out
        this.dataItem.shiftCode = shift.shift_master.schedule_code
      }
    },
    cannotEditTodayAndPreviousSchedule(item) {
      const today = moment().format('YYYY-MM-DD')
      const isNotToday = moment(item.value, 'DD-MM-YYYY').diff(today, 'days')
      if (isNotToday > -1) {
        return false
      } else {
        this.showMessage('You can only edit shift data one day before the scheduled shift', 'warning')
        return true
      }
    },
    clickSchedule(data, item) {
      if (this.cannotEditTodayAndPreviousSchedule(item)) return null
      if (item.value == 'name') return null
      const user = this.users.find(e => { return e.id == data.id })
      const joinDate = moment(this.patternByGroup[user.groupId].activate_date, 'DD-MM-YYYY')
      const dateChoosen = moment(item.value, 'DD-MM-YYYY')
      const diffDays = dateChoosen.diff(joinDate, 'days')
      const scheduleNow = diffDays % this.patternByGroup[user.groupId].shift_days.length
      const pattern = this.getPatternForThatDate(user.groupId, scheduleNow)
      this.masterShift = pattern.pattern

      this.reset = false
      let Data = {
        id: data.id,
        name: data.name,
        date: moment(item.value, "DD-MM-YYYY").format("YYYY-MM-DD"),
      }
      const temp = data[item.value]
      if (temp) {
        this.isEdit = true
        this.disableEdit = true
        Data.scheduleId = temp.id
        if (temp.shift_master) {
          Data.shiftId = temp.shift_master.id
          Data.shiftDescription = temp.shift_master.description
          Data.shiftCode = temp.shift_master.schedule_code
          Data.shiftWorkIn = temp.shift_master.work_in
          Data.shiftWorkOut = temp.shift_master.work_out
          Data.shiftBreakIn = temp.shift_master.break_in
          Data.shiftBreakOut = temp.shift_master.break_out
        }
      } else {
        this.isEdit = false
        this.disableEdit = true
      }
      Data.patternName = pattern.name
      Data.day = pattern.day
      Data.tolerance = pattern.tolerance
      Data.interval = pattern.interval
      this.dataItem = Object.assign({}, Data)
      this.dialog = true
    },
    async onWeekChange(type) {
      if (!this.inProggress) {
        switch (type) {
          case 'next':
            this.date.week++
            break
          case 'prev':
            this.date.week--
            break
          default:
            this.date.week = moment().week()
            break
        }
        this.date = this.getDateByWeek(this.date.week)
        this.inProggress = true
        await this.refreshView(this.userSelected, this.groupSearch)
        await this.insertDataForWeek()
      } else {
        this.showMessage('Proccessing please wait.', 'info')
      }

      // this.masterShift = await this.getShiftMaster()
    },
    onDateChange() {
      this.menu_date = false
      this.getShiftMasterForDate()
    },
    changeUser() {
      this.getShiftMasterForDate()
    },
    getShiftMasterForDate() {
      if (this.dataItem.id && this.dataItem.date) {
        const user = this.users.find(e => { return e.id == this.dataItem.id })
        const joinDate = moment(this.patternByGroup[user.groupId].activate_date, 'DD-MM-YYYY')
        const dateChoosen = moment(this.dataItem.date, 'YYYY-MM-DD')
        const diffDays = dateChoosen.diff(joinDate, 'days')
        const scheduleNow = diffDays % this.patternByGroup[user.groupId].shift_days.length
        const pattern = this.getPatternForThatDate(user.groupId, scheduleNow)
        this.masterShift = pattern.pattern
        this.dataItem.patternName = pattern.name
        this.dataItem.day = pattern.day
        this.dataItem.tolerance = pattern.tolerance
        this.dataItem.interval = pattern.interval
      }
    },
    getDateByWeek(week) {
      if (!week) week = moment().week()
      const now = moment()
      const length = 7
      const date = [{ text: this.$i18n.t('employee'), value: 'name' }]
      for (let i = 1; i <= length; i++) {
        date.push({
          text: now.clone().week(week).startOf('isoWeek').weekday(i).locale(this.$i18n.t('lang')).format('ddd DD-MMM'),
          value: now.clone().week(week).startOf('isoWeek').weekday(i).format('DD-MM-YYYY')
        })
      }

      this.headers = date
      const start = now.clone().week(week).startOf('isoWeek').format('DD-MM-YYYY')
      return {
        start,
        end: moment(start, 'DD-MM-YYYY').add(6, 'days').format('DD-MM-YYYY'),
        week,
        date
      }
    },
    filterByRegisteredUser(data, isGroup = false) {
      const result = []
      if (data) {
        data.map(item => {
          if (item.id.length == 28 && item.is_shifted) {
            if (isGroup) {
              item.groupId = item.group_id
              item.full_name = item.fullname
            }
            result.push(item)
          }
        })
      }
      return result
    },
    async getUserList() {
      const result = await this.$store.dispatch('getEmployeeList', {companyId: this.company_id, pageSize:2000, page:0})
      let data = []
      if (result) {
        data = this.filterByRegisteredUser(result.rows)
      }
      return data
    },
    async getDownloadList() {
      return new Promise(async (resolve) => {
        const groupId = this.groupSearch
        const month = moment(this.date.start, 'DD-MM-YYYY').format('MM')
        let url = `${this.baseUrl}/download/schedule?companyId=${this.company_id}&month=${month}`
        // let url = `${this.baseUrl}/scheduleshift/download?companyId=${this.company_id}&month=${month}`
        if (groupId) {
          url = `${url}&groupId=${groupId}`
        }
        window.open(url, '_blank')
        resolve()
      })
    },
    getDownloadTitle() {
      const companyName = this.$store.state.companyName
      const date = moment().format('MMM YYYY')
      return `Schedule ${companyName} - ${date}.xls`
    },
    async getUserListByGroupId(groupId) {
      const result = await this.$store.dispatch('getEmployeeListByGroup', {groupId, mobile:0})
      let data = []
      if (result) {
        data = this.filterByRegisteredUser(result.team_member, true)
      }
      return data
    },
    async getScheduleByUser(item) {
      this.loading = true
      const result = await this.$store.dispatch('getScheduleShiftByUser', {userId: item, startDate: this.date.start, endDate: this.date.end})
      this.loading = false
      let data = []
      if (result) {
        data = result
      }
      return this.listDataSchedule(data)
    },
    async getScheduleByGroup(group) {
      this.loading = true
      const result = await this.$store.dispatch('getScheduleShiftByGroup', {groupId: group, startDate: this.date.start, endDate: this.date.end})
      this.loading = false
      return this.listDataSchedule(result)
    },
    async getSchedule() {
      this.loading = true
      const result = await this.$store.dispatch('getScheduleShiftByCompany', {companyId: this.company_id, startDate: this.date.start, endDate: this.date.end})
      this.loading = false
      return this.listDataSchedule(result)
    },
    async getSchedulePattern() {
      this.loading = true
      const result = await this.$store.dispatch('getShiftPatternByCompany', {companyId: this.company_id})
      this.loading = false
      return result
    },
    async getSchedulePatternByGroup(groupId) {
      this.loading = true
      const result = await this.$store.dispatch('getSchedulePatternByGroup', {groupId})
      this.loading = false
      return result
    },
    async getShiftMaster() {
      return await this.$store.dispatch('getScheduleShiftMasterByCompany', {companyId: this.company_id, startDate: this.date.start, endDate: this.date.end})
    },
    async getGroupList() {
      const result = await this.$store.dispatch('getGroupByCompany', {companyId: this.company_id})
      let data = []
      if (result) {
        result.map(item => { if (item.is_shifted) data.push(item) })
        if(this.role != 3){
        data.unshift({ alias: this.$i18n.t('all'), id: null })
        }
      }
      return data
    },
    async getGroupListByHierarcy() {
      const result = await this.$store.dispatch('getGroupListById', {id: this.groupId})
      let data = []
      if (result) {
        result.map(item => {
          // if (item.is_shifted) {
          item.alias = item.name
          data.push(item)
          // }
        })
      }
      return data
    },
    async refreshView(item = null, group = null, searchBy = null) {
      switch (true) {
        case ((item != null) && (group == null)):
          await this.getDataByRole()
          this.dataSchedule = await this.getScheduleByUser(item)
          this.users.unshift({ full_name: this.$i18n.t('all'), id: null })
          if(this.role == 3){
            await this.insertDataForWeek()
          }
          break
        case (item != null && group != null && searchBy == 'byUser'):
          this.dataSchedule = await this.getScheduleByUser(item)
          this.users = await this.getUserListByGroupId(group)
          this.users.unshift({ full_name: this.$i18n.t('all'), id: null })
          if(this.role == 3){
            await this.insertDataForWeek()
          }
          break
        case (item != null && group != null && searchBy == 'byGroup'):
          this.dataSchedule = await this.getScheduleByGroup(group)
          this.users = await this.getUserListByGroupId(group)
          this.users.unshift({ full_name: this.$i18n.t('all'), id: null })
          this.userSelected = null
          if(this.role == 3){
            await this.insertDataForWeek()
          }
          break
        case (item == null && group != null):
          this.dataSchedule = await this.getScheduleByGroup(group)
          this.users = await this.getUserListByGroupId(group)
          this.users.unshift({ full_name: this.$i18n.t('all'), id: null })
          this.userSelected = null
          if(this.role == 3){
            await this.insertDataForWeek()
          }
          break
        case (item == null && group == null && searchBy == null):
        default:
          await this.getDataByRole()
          break
      }
    },
    mappingScheduleGroupAsFullSchedule() {
      const result = []
      return result
    },
    listDataSchedule(result) {
      const data = []
      result.map((item) => {
        if (data.length > 0) {
          const ind = data.findIndex(e => {
            return e.id == item.userId
          })
          if (ind >= 0) {
            data[ind] = Object.assign(data[ind], { [item.date]: item })
          } else {
            data.push({ id: item.userId, name: item.user.full_name, [item.date]: item })
          }
        } else {
          data.push({ id: item.userId, name: item.user.full_name, [item.date]: item })
        }
      })
      return data
    },
    mappingScheduleAsPerUserInTheGroup(data) {
      const result = []
      if (this.users) {
        this.users.map(user => {
          const schedule = data.find(e => { return e.id == user.id })
          if (schedule) {
            result.push(schedule)
          }
        })
      }
      return result
    },
    async insert(form) {
      if (!this.formValidation(form)) return null
      const data = [{
        date: this.formatDate(form.date),
        userId: form.id,
        shiftMasterId: form.shiftId,
        tolerance: form.tolerance,
        interval: form.interval
      }]
      this.loading = true
      const result = await this.$store.dispatch('saveScheduleWork', data)
      this.loading = false  
      if (result) {
        this.showMessage(this.$i18n.t('alert_save'), 'success')
        this.refreshView(this.userSelected, this.groupSearch)
        this.dialog = false
      }
    },
    async insertBulk(bulkData) {
      this.bulkLoading = true
      const result = await this.$store.dispatch('saveScheduleWork', bulkData)
      this.bulkLoading = false
      if (result) {
        this.refreshView(this.userSelected, this.groupSearch)
      }
    },
    async update(form) {
      if (!this.formValidation(form)) return null
      const data = {
        id: form.scheduleId,
        date: this.formatDate(form.date),
        userId: form.id,
        shiftMasterId: form.shiftId,
        tolerance: form.tolerance,
        interval: form.interval
      }
      this.loading = true
      const result = await this.$store.dispatch('editScheduleWork', data)
      this.loading = false
      if (result) {
        this.showMessage(this.$i18n.t('alert_edit'), 'success')
        this.refreshView(this.userSelected, this.groupSearch)
        this.dialog = false
      }
    },
    async remove(form) {
      const data = { id: form.scheduleId }
      this.deleteLoading = true
      const result = await this.$store.dispatch('deleteScheduleWork', data)
      this.deleteLoading = false
      if (result) {
        this.showMessage(this.$i18n.t('alert_delete'), 'success')
        this.refreshView(this.userSelected, this.groupSearch)
        this.deleteDialog = false
        this.dialog = false
      }
    },

    showDeleteDialog() {
      this.deleteDialog = true
    },
    showMessage(msg, type) {
      this.$store.dispatch('nShowMessage', {type, msg})
    },
    showNotif(text, mode, title) {
      this.notif.text = text
      this.notif.mode = mode
      this.notif.title = title
      this.notif.show = true
    },
    formatDate(date) {
      return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY")
    },
    sortingUserByGroup(users) {
      const data = {}
      users.map(user => {
        if (user.id != null) {
          if (!data[user.groupId]) {
            data[user.groupId] = []
          }

          data[user.groupId].push(user)
        }
      })
      return { data, key: Object.keys(data) }
    },
    async batchPatternByGroup(groupIds) {
      const query = []
      const data = {}
      groupIds.map(item => {
        query[item] = this.getSchedulePatternByGroup(item)
      })
      const array = await Promise.all(query)
      groupIds.map(item => {
        data[item] = array[item]
      })
      return data
    },
    async mappingDataForSend({ data, key }, pattern, dates, scheduleExist) {
      const result = []
      const role = this.$store.state.role
      // const userLoginGroupId = this.$store.state.user.detail.groupId
      dates.shift()
      key.map(item => {
        if (pattern[item]) {
          if (pattern[item].shift_days) {
            if (pattern[item].shift_days.length > 0) {
              data[item].map(user => {
                dates.map((date) => {
                  const joinDate = moment(pattern[item].activate_date, 'DD-MM-YYYY')
                  const dateChoosen = moment(date.value, 'DD-MM-YYYY')
                  const diffDays = dateChoosen.diff(joinDate, 'days')
                  if (diffDays >= 0) {
                    const scheduleNow = Math.abs(diffDays % pattern[item].shift_days.length)
                    const checkschedule = scheduleExist.find(e => { return e.id == user.id })
                    if (pattern[item].shift_days[scheduleNow]) {
                      const row = {
                        date: date.value,
                        userId: user.id,
                        shiftMasterId: pattern[item].shift_days[scheduleNow].shift_patterns.find(e => { return e.default == true }).shiftMasterId,
                        tolerance: pattern[item].tolerance,
                        interval: pattern[item].interval,
                      }
                      if (user.status == 1 && user.is_shifted == true) {
                        if (this.groupSearch == null) {
                          if (checkschedule) {
                            if (!checkschedule[date.value]) {
                              if (role == 2 || role == 0 || role == 3) {
                                result.push(row)
                              }
                            }
                          } else {
                            if (role == 2 || role == 0 || role == 3) {
                              result.push(row)
                            }
                          }
                        } else {
                          if (user.groupId == this.groupSearch) {
                            if (checkschedule) {
                              if (!checkschedule[date.value]) {
                                if (role == 2 || role == 0 || role == 3) {
                                  result.push(row)
                                }
                              }
                            } else {
                              if (role == 2 || role == 0 || role == 3) {
                                result.push(row)
                              }
                            }
                          }
                        }
                      }

                    }
                  }
                })
              })
            }
          }
        }
      })
      return result
    },

    async insertDataForWeek() {
      const user = this.userSelected ? [this.users.find(e => { return e.id == this.userSelected })] : this.users
      const userByGroup = this.sortingUserByGroup(user)
      // const patternByGroup = await this.mappingDataForPattern(userByGroup.key)
      const patternByGroup = await this.batchPatternByGroup(userByGroup.key)
      this.patternByGroup = Object.assign({}, patternByGroup)
      const result = await this.mappingDataForSend(userByGroup, patternByGroup, [].concat(this.date.date), this.dataSchedule)
      if (result.length > 0) {
        this.showMessage('Insert data schedule this week', 'success')
        await this.insertBulk(result)
      }
      this.inProggress = false
    },
    // async mappingDataForPattern(key) {
    //   const result = []
    //   const rawPattern = await this.getSchedulePattern()
    //   key.map(groupId => {
    //     const pattern = rawPattern.find(e => {return e.group_id == groupId})
    //     if (pattern) {
    //       result.push(pattern)
    //     }
    //   })
    //   return result
    // }

    getPatternForThatDate(groupId, scheduleNow) {
      let result = { name: '', pattern: [], day: 0 }
      let data = this.patternByGroup[groupId].shift_days[scheduleNow]
      if (data) {
        const name = this.patternByGroup[groupId].schedule_name
        data.shift_patterns.map(item => {
          item.id = item.shiftMasterId
        })

        result.name = name
        result.pattern = data.shift_patterns
        result.day = data.day
        result.tolerance = this.patternByGroup[groupId].tolerance
        result.interval = this.patternByGroup[groupId].interval
      } else {
        this.showMessage('Schedule not found or before effective date start', 'warning')
      }
      return result
    },
    formValidation(form) {
      if (!form.id) return false
      if (!form.date) return false
      if (!form.shiftId) return false
      return true
    },
    async getDataByRole(getSchedule = true) {
      return new Promise(async (resolve) => {
        if (this.role == 2 || this.role == 0) {
          this.users = await this.getUserList()
          this.users.unshift({ full_name: this.$i18n.t('all'), id: null })

          if (getSchedule) {
            this.dataSchedule = await this.getSchedule()
          }
          this.searchGroupList = this.groupList
          resolve(true)
        } else {
          const groupHierarcy = await this.getGroupListByHierarcy()
          const groupList = []
          this.users = []
          await Promise.all(groupHierarcy.map(async group => {
            groupList.push(group)
            const user = await this.getUserListByGroupId(group.id)
            await Promise.all(user.map(item => { this.users.push(item) }))
          }))
          this.searchGroupList = groupList
          this.groupSearch = `${this.groupId}`
          if (getSchedule) {
            const fullSchedule = await this.getSchedule()
            this.dataSchedule = this.mappingScheduleAsPerUserInTheGroup(fullSchedule)
          }
          resolve(true)
        }
      })
    }
  },
  computed: {
    dateStartFormatted() {
      return this.date_start ? moment(this.date_start, "YYYY-MM-DD").format("DD-MM-YYYY") : ""
    },
    dateFormatted() {
      return this.dataItem.date ? moment(this.dataItem.date, "YYYY-MM-DD").format("DD-MM-YYYY") : ""
    },
    tableHeader() {
      return this.headers
    }
  },
  async created() {
    // this.downloadList = await this.getDownloadList()
    this.date = this.getDateByWeek()
    if(this.role != 3){
    this.groupList = await this.getGroupList()
    }else{
    this.groupList = await this.getGroupListByHierarcy()
    }
    this.searchGroupList = this.groupList
    // Get first data only the first group
    if (this.groupList.length > 1) {
      this.groupSearch = this.groupList[0].id
    }

    // Get data for all group deppend by role (set false to get only the user)
    await this.getDataByRole(false)

    await this.refreshView(null, this.groupSearch, null)

    await this.insertDataForWeek()
  },
  watch: {
    dialog() {
      if (this.$refs.form && this.reset) { this.$refs.form.reset(); this.masterShift = [] }
    },
  }

}
</script>
<style>
.not-bold {
  font-weight: lighter !important;
}

.blue-outline {
  border: 1px solid #0052cc !important;
}

.blue-outline .colored-text {
  color: #0052cc !important;
  white-space: nowrap !important;
}
.red-outline {
  border: 1px solid #ff5630 !important;
}

.red-outline .colored-text {
  color: #ff5630 !important;
  white-space: nowrap !important;
}
.inherit-color {
  color: transparent;
}

/* .find-group, .find-user, .shift-name {
  position: relative;
}

.find-group::before {
  content: 'Find Group';
  position: absolute;
  top: -10px;
  color: #868686;
  font-size: 12px;

}

.shift-name::before {
  content: 'Shift Name';
  position: absolute;
 top: -10px;
  color: rgba(0, 0, 0, 0.38);
  font-size: 12px;
  
}


.find-user::before {
  content: 'Find User';
  position: absolute;
  top: -10px;
  color: #868686;
  font-size: 12px;

} */
</style>